import { useGetPatientById } from "@elation/api-client/src/stitch-web";
import type { Patient } from "@elation/api-client/src/stitch-web/models";

import { usePatientId } from "../domain";

export function useCurrentPatient(): Patient | null {
  const [patientId] = usePatientId();

  const { data: patientData } = useGetPatientById(Number(patientId), {
    query: {
      enabled: patientId != null,
    },
  });

  return patientData?.data ?? null;
}
